import { Checkbox, Col, Form, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';

const BalanceteCheckboxs = () => {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;

  return (
    <Form.Item shouldUpdate>
      {({ getFieldValue }) => {
        const situation = getFieldValue('situation');

        return (
          <Form.Item>
            <Title level={5}>
              {intl({ id: 'financial.billsToPay.form.display' })}
            </Title>
            <Row>
              <Col>
                <Form.Item
                  name="showPayablesAndReceivables"
                  valuePropName="checked"
                >
                  <Checkbox>
                    {intl({
                      id: 'financial.billsToPay.form.display.payReceive',
                    })}
                  </Checkbox>
                </Form.Item>
              </Col>

              <Col>
                <Form.Item name="tariffs" valuePropName="checked">
                  <Checkbox>
                    {intl({ id: 'financial.billsToPay.form.display.tariffs' })}
                  </Checkbox>
                </Form.Item>
              </Col>

              <Col>
                <Form.Item name="showRefund" valuePropName="checked">
                  <Checkbox>
                    {intl({
                      id: 'financial.billsToPay.form.display.showRefund',
                    })}
                  </Checkbox>
                </Form.Item>
              </Col>

              {[...situation].includes('LIQUIDATED') ? (
                <Col>
                  <Form.Item name="showBankEntries" valuePropName="checked">
                    <Checkbox>
                      {intl({
                        id: 'financial.billsToPay.form.display.singleEntries',
                      })}
                    </Checkbox>
                  </Form.Item>
                </Col>
              ) : null}
            </Row>
          </Form.Item>
        );
      }}
    </Form.Item>
  );
};

export default BalanceteCheckboxs;
